import { gql } from '@apollo/client';

// Query to resolve the current user from JWT — no variables needed.
// The backend extracts the JWT sub and resolves the correct DB user.
export const GET_ME = gql`
  query GetMe {
    me {
      id
      name
      email
      roles
    }
  }
`;

export interface GetMeQueryResponse {
  me: {
    id: string;
    name: string;
    email: string;
    roles: string[];
  } | null;
}

// Query to get a single user by ID
export const GET_USER = gql`
  query GetUser($id: ID!) {
    user(id: $id) {
      id
      name
      email
      roles
    }
  }
`;

// Query to get multiple users with pagination
export const GET_USERS = gql`
  query GetUsers($limit: Int, $offset: Int) {
    users(limit: $limit, offset: $offset) {
      users {
        id
        name
        email
        roles
        last_login
      }
      total
    }
  }
`;

// Mutation to create a new user
export const CREATE_USER = gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      id
      name
      email
      roles
    }
  }
`;

// Mutation to update an existing user
export const UPDATE_USER = gql`
  mutation UpdateUser($id: ID!, $input: UpdateUserInput!) {
    updateUser(id: $id, input: $input) {
      id
      name
      email
      roles
    }
  }
`;

// Mutation to delete a user
export const DELETE_USER = gql`
  mutation DeleteUser($id: ID!) {
    deleteUser(id: $id)
  }
`;

// Mutation to transfer ownership
export const TRANSFER_OWNERSHIP = gql`
  mutation TransferOwnership($newOwnerId: ID!) {
    transferOwnership(newOwnerId: $newOwnerId)
  }
`;

// TypeScript interfaces for the queries and mutations
export interface User {
  id: string;
  name: string;
  email: string;
  roles: string[];
  last_login?: string;
}

export interface GetUserQueryVariables {
  id: string;
}

export interface GetUserQueryResponse {
  user: User;
}

export interface GetUsersQueryVariables {
  limit?: number;
  offset?: number;
}

export interface GetUsersQueryResponse {
  users: {
    users: User[];
    total: number;
  };
}

export interface CreateUserInput {
  email: string;
  name: string;
  password: string;
  roles: string[];
}

export interface CreateUserMutationVariables {
  input: CreateUserInput;
}

export interface CreateUserMutationResponse {
  createUser: User;
}

export interface UpdateUserInput {
  email?: string;
  roles?: string[];
}

export interface UpdateUserMutationVariables {
  id: string;
  input: UpdateUserInput;
}

export interface UpdateUserMutationResponse {
  updateUser: User;
}

export interface DeleteUserMutationVariables {
  id: string;
}

export interface DeleteUserMutationResponse {
  deleteUser: boolean;
}

export interface TransferOwnershipMutationVariables {
  newOwnerId: string;
}

export interface TransferOwnershipMutationResponse {
  transferOwnership: boolean;
}
